import React from 'react';
import Modal from './Modal';
import Button from './Button';

const ConfirmModal = ({
   isOpen,
   title,
   message,
   onConfirm,
   onCancel,
   confirmText = 'Delete',
   loading = false,
}) => {
   return (
      <Modal isOpen={isOpen} onClose={onCancel} title={title}>
         <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">{message}</p>
         <div className="flex justify-end gap-3">
            <Button variant="secondary" size="sm" onClick={onCancel} disabled={loading}>
               Cancel
            </Button>
            <Button variant="danger" size="sm" onClick={onConfirm} disabled={loading}>
               {loading ? 'Deleting...' : confirmText}
            </Button>
         </div>
      </Modal>
   );
};

export default ConfirmModal;
